// PDF.js v5 ESM imports and worker configuration
// Using Vite's ?worker to bundle the worker properly

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - pdfjs-dist provides its own types but path mapping can confuse TS
import * as pdfjsLib from 'pdfjs-dist/build/pdf.mjs'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.mjs?worker'

// Configure worker (v5 supports workerSrc string or workerPort Worker)
try {
  // Many bundlers return a Worker constructor for ?worker; PDF.js also supports workerPort
  // Prefer workerPort when available for better compatibility
  // If import returns a constructor, instantiate it; otherwise assign as src
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const MaybeWorkerCtor: any = pdfjsWorker as any
  if (typeof MaybeWorkerCtor === 'function') {
    // v5 recommended: use workerPort
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (pdfjsLib as any).GlobalWorkerOptions.workerPort = new MaybeWorkerCtor()
  } else {
    // Fallback to workerSrc
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(pdfjsLib as any).GlobalWorkerOptions.workerSrc = pdfjsWorker as unknown as string
  }
} catch {
  // noop - fallback to fake worker if necessary
}

export { pdfjsLib }

export async function loadPdf(url: string) {
  const loadingTask = pdfjsLib.getDocument(url)
  const pdf = await loadingTask.promise
  return pdf
}


